import type { Aptrinsic } from "@repo/ui/lib/analytics";

/**
 * Gainsight PX tag keys for the CCP product (design doc 0026: Tiger Agent reports under CCP's
 * bucket rather than a product of its own). Same keys as web-react-ui-toolkit's `index.html`.
 */
export const GAINSIGHT_KEYS = {
  prod: "AP-AG6XBGKNLUZ7-2",
  stage: "AP-AG6XBGKNLUZ7-2-2",
} as const;

const SDK_URL = "https://web-sdk.aptrinsic.com/api/aptrinsic.js";

type QueuedAptrinsic = Aptrinsic & { q?: unknown[][]; p?: string };

/**
 * Install the Gainsight PX command queue and inject the SDK script — the vendor bootstrap
 * snippet, run programmatically. Calls made before the script loads are queued by the stub and
 * replayed once it arrives. Safe to call more than once.
 */
export function loadGainsight(isProduction: boolean): void {
  if (window.aptrinsic) return;
  const apiKey = isProduction ? GAINSIGHT_KEYS.prod : GAINSIGHT_KEYS.stage;

  const stub: QueuedAptrinsic = (...args: unknown[]) => {
    (stub.q ??= []).push(args);
  };
  stub.p = apiKey;
  window.aptrinsic = stub;

  const script = document.createElement("script");
  script.async = true;
  script.src = `${SDK_URL}?a=${apiKey}`;
  document.head.appendChild(script);
}
